<app-initial-form-question
  [control]="form.get('postSchoolPlan')"
  question="¿Qué harás inmediatamente después de terminar el colegio?"
  [options]="postSchoolPlanOptions">
</app-initial-form-question>